var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.35,
    height: 29.045,
    viewBox: "0 0 75.35 29.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4836",
    "data-name": "Group 4836",
    transform: "translate(-319 -621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M9.354.872h66L66,29.918H0Z",
    transform: "translate(319 620.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4428",
    "data-name": "Group 4428",
    transform: "translate(331 627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4426",
    "data-name": "Group 4426",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3051",
    "data-name": "Group 3051",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,.016H5.653L7.5,9.532h.058l2.6-9.516H16.67l2.557,9.516h.058L21.112.016h5.249L23.073,15.251H15.708l-2.48-9.263h-.057l-2.5,9.263H3.249Z",
    transform: "translate(0 -0.016)",
    fill: "#006937",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M43.6.027h7.422l2.5,9.263h.058L56.063.027h7.364l3.289,15.235H61.466L59.641,5.745h-.058l-2.557,9.516H50.508l-2.6-9.516h-.057l-1.847,9.516H40.355",
    transform: "translate(-17.271 -0.02)",
    fill: "#eba900",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(49.857 14.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M.217,1.107A.716.716,0,0,1,.9.341a.715.715,0,0,1,.68.766.806.806,0,0,1-.194.548A.633.633,0,0,1,.9,1.877a.633.633,0,0,1-.488-.221.807.807,0,0,1-.2-.549ZM.9,2.03a.88.88,0,0,0,.847-.924A.878.878,0,0,0,.9.188a.879.879,0,0,0-.853.919A.881.881,0,0,0,.9,2.03ZM.724,1.179H.892l.256.462h.164l-.275-.469A.267.267,0,0,0,1.288.879c0-.21-.113-.3-.342-.3H.577V1.641H.724Zm0-.136V.715h.2c.1,0,.211.023.211.154,0,.165-.112.174-.236.174Z",
    transform: "translate(-0.048 -0.188)",
    fill: "#006937",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWmLogo);
export default __webpack_public_path__ + "static/media/WM-logo.62930e36870440bcbe555b3a0c64a713.svg";
export { ForwardRef as ReactComponent };